import { useEffect, useState } from "react";
import FocusLock from "react-focus-lock";
import { Button, Icon, TextInput } from "@/shared/ui";

type Props = {
  onCancel: () => void;
  onContinue: () => void;
  email: string;
  onChangeEmail: (value: string) => void;
  error?: string;
  loading?: boolean;
};

export default function PlayerMenuSettingsSafetyEnterCurrEmail({
  onCancel,
  onContinue,
  onChangeEmail,
  email,
  error = "",
  loading,
}: Props) {
  const [touch, setTouch] = useState(false);

  useEffect(() => {
    if (!touch && email.length) {
      setTouch(true);
    }
  }, [email, touch]);

  return (
    <FocusLock className="contents">
      <div className="gap-3 grow flex flex-col h-full">
        <div>
          <div className="text-white text-15 font-medium">
            Введите текущий Email адрес привязанный к аккаунте
          </div>
          <div className="text-white/60 text-15 font-medium mt-1">
            Отправим код подтверждения на почту
          </div>
          <TextInput
            type="text"
            placeholder="Введите Email"
            value={email}
            icon={<Icon name="mail" className="w-4.5" />}
            invalid={touch && !email ? "Введите почту" : ""}
            onChange={onChangeEmail}
            className="text-center mt-2.5"
            loading={loading}
            disabled={loading}
          />
        </div>
        <div className="mt-auto grid gap-2.5">
          {!!error && <div className="alert alert--danger">*{error}</div>}
          <div className="grid grid-cols-2 items-center gap-2 w-full">
            <Button variant="solid-surface-gradient" onClick={onCancel}>
              Отменить
            </Button>
            <Button onClick={onContinue} disabled={!email || loading}>
              Далее
            </Button>
          </div>
        </div>
      </div>
    </FocusLock>
  );
}
